module.exports = __webpack_public_path__ + "static/media/aj-logo.c3d22eb8.png";